import { render, staticRenderFns } from "./CompilationItem.vue?vue&type=template&id=1fbe5126&scoped=true&"
import script from "./CompilationItem.vue?vue&type=script&lang=js&"
export * from "./CompilationItem.vue?vue&type=script&lang=js&"
import style0 from "./CompilationItem.vue?vue&type=style&index=0&id=1fbe5126&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe5126",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default})
